<!-- src/apps/colonel/views/ColonelSystemAuthDB.vue -->

<script setup lang="ts">
  // No i18n needed - admin-only view with hardcoded strings
</script>

<template>
  <div>
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
        Auth Database (SQLite/PostgreSQL)
      </h1>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
        Authentication database information
      </p>
    </div>

    <div class="rounded-lg bg-white p-6 shadow dark:bg-gray-800">
      <div class="text-center text-gray-600 dark:text-gray-400">
        <p class="mb-2 text-lg">Coming Soon</p>
        <p class="text-sm">Authentication database metrics will be available here</p>
      </div>
    </div>
  </div>
</template>
